import cs from './default/cs.json'
import {useUniWebTemplate} from "~/composables/useUniWebTemplate";
export default defineI18nLocale(async locale => {
  try {
    // IMPORT
    const template = useUniWebTemplate().uniWebTemplateNameLowerCase
    const templateLocales = await import(`./${template}/cs.json`)
    return {
      ...cs,
      ...templateLocales.default
    }
  } catch (e) {
    console.log('Locale.error', e)
  }

  return cs
})